import productService from "@/services/productService";
import Vue from "vue";
import axios from "axios";

const ITEMS_PER_PAGE = 24;

var search_request;

const state = {
    limit_reached: false,
    products_by_image_loading: false,
    search_image: null,
    products_by_image: [],

    products_loading: true,
    products: [],
    productsList: [],
    currentCursor: {
        next: undefined,
        prev: undefined,
    },
    newCursor: {
        next: null,
        prev: null,
    },
    filters: {
        search_text: undefined,
        compositions: [],
        colors: [],
        options: [],
        places: [],
        prices: [],
        is_luxury: undefined,
        is_large_sizes: undefined,
        is_sale: undefined,
        min_price: undefined,
        max_price: undefined,
        seller: undefined,
        category: undefined,
    }
};

const actions = {
    getProducts({commit}, resetList = true) {
        state.products_loading = true;

        const { search_text, category, ...filters } = state.filters;

        const params = {
            search_text: search_text || undefined,
            category: search_text ? undefined : category,
            ...filters,
            ...state.currentCursor,
            limit: ITEMS_PER_PAGE,
        }

        if (resetList) {
            commit("setProducts", {items: [], next: null, prev: null});
        }

        return new Promise((resolve, reject) => {
            productService.fetchProducts(params)
                .then((response) => {
                    if (resetList)
                        commit("setProducts", response);
                    else
                        commit("addProducts", response);
                    state.products_loading = false;
                    resolve(response);
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось загрузить товары.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    state.products_loading = false;
                    reject();
                });
        });
    },
    getProductsList({commit}, payload) {
        const { resetList, ...data } = payload;

        if (resetList) {
            commit("setProductsList", []);
        }

        return new Promise((resolve, reject) => {
            productService.fetchProductsList(data)
                .then((response) => {
                    if (resetList)
                        commit("setProductsList", response);
                    else
                        commit("addProductsList", response);
                    resolve(response);
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось загрузить товары.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject(error);
                });
        });
    },
    getProduct(store, params) {
        return new Promise((resolve, reject) => {
            productService.getProduct(params)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    Vue.toasted.show(`<div>ОШИБКА<br>Не удалось загрузить товар.<br>Код ошибки: ${error.response ? error.response.status : 0}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`, {
                        duration: 10000,
                        type: 'error',
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    reject();
                });
        });
    },
    searchByImageProducts({state, commit}) {
        if (!state.search_image) {
            return;
        }

        if (search_request) {
            search_request.cancel();
        }
        const CancelToken = axios.CancelToken;
        search_request = CancelToken.source();

        state.limit_reached = false;
        state.products_by_image_loading = true;
        state.products_by_image = [];

        const data = new FormData();
        data.append("image", state.search_image);

        return new Promise((resolve, reject) => {
            productService.searchByImageProducts(data, search_request.token)
                .then((response) => {
                    commit("setProductsByImage", response);
                    state.products_by_image_loading = false;
                    resolve(response);
                })
                .catch((error) => {
                    if (error.__CANCEL__) {
                        return
                    }
                    const errorCode = error.response ? error.response.status : 0;
                    let message = `<div>ОШИБКА<br>Не удалось найти товар по изображению.<br>Код ошибки: ${errorCode}<br>Описание: ${error.response ? error.response.data.detail || "Без описания." : error}</div>`
                    let type = 'error';
                    let duration = 10000;
                    if (errorCode === 402) {
                        state.limit_reached = true;
                        message = `<div>ВНИМАНИЕ!</br>${error.response.data.detail}<br/><strong>Активируйте безлимитный поиск.</strong></div>`
                        type = 'info';
                        duration = 30000;
                    }
                    Vue.toasted.show(message, {
                        duration: duration,
                        type: type,
                        position: 'bottom-center',
                        action: {
                            text: 'Ок',
                            onClick: (e, toastObject) => {
                                toastObject.goAway(0);
                            }
                        },
                    });
                    state.products_by_image_loading = false;
                    reject(errorCode);
                });
        });
    }
};

const mutations = {
    addProducts(state, data) {
        state.newCursor.next = data.next;
        state.newCursor.prev = data.prev;
        state.products = [...state.products, ...data.items];
    },
    setProducts(state, data) {
        state.newCursor.next = data.next;
        state.newCursor.prev = data.prev;
        state.products = data.items;
    },
    addProductsList(state, data) {
        state.productsList = [...state.productsList, ...data];
    },
    setProductsList(state, data) {
        state.productsList = data;
    },
    setProductsByImage(state, data) {
        state.products_by_image = data;
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}